import {
    Button,
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/ui/design-system/components';

/**
 * Shown when a save is rejected with 409 — the report changed in another tab or
 * device. Reload pulls the latest (discarding the local edits the user chooses
 * to abandon); Dismiss closes and re-enables saving, so the next conflicting
 * save re-surfaces this rather than silently blocking.
 *
 * `onSaveAsCopy` is an optional slot: when provided, a "Save as copy" action is
 * rendered. It's the seam for the deferred branch that forks the in-progress
 * edits into a new report — no structural change needed to add it.
 */
function ReportConflictDialog({ open, onReload, onDismiss, onSaveAsCopy }) {
    return (
        <Dialog
            open={open}
            onOpenChange={(next) => {
                if (!next) onDismiss?.();
            }}
        >
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle>Report changed elsewhere</DialogTitle>
                    <DialogDescription>
                        This report was changed in another tab or device. Reload
                        to get the latest version. Your unsaved changes
                        won&apos;t be sent until you reload.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button variant="outline" onClick={onDismiss}>
                        Dismiss
                    </Button>
                    {onSaveAsCopy && (
                        <Button variant="outline" onClick={onSaveAsCopy}>
                            Save as copy
                        </Button>
                    )}
                    <Button onClick={onReload}>Reload</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default ReportConflictDialog;
